// extracted by mini-css-extract-plugin
export var centerResponsive = "Section-module--centerResponsive--fbc30";
export var container = "Section-module--container--0fecd";
export var fullResponsive = "Section-module--fullResponsive--66deb";